"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// useUnreadCount.ts
var react_1 = require("react");
var notificationsStore_1 = require("../storage/notificationsStore");
function useUnreadCount(initial) {
    if (initial === void 0) { initial = 0; }
    return (0, react_1.useSyncExternalStore)(notificationsStore_1.subscribe, notificationsStore_1.getUnreadCount, function () { return initial; });
}
exports.default = useUnreadCount;
